import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ProductVideoDto
*  Видео продукта (RFC-013)
*/
export class ProductVideoDto extends ActiveModel {

/**
  * id
  * Идентификатор ресурса-видео<br>
  */
  @ActiveField('')
  id: string = ''


/**
  * displayName
  * Отображаемое название<br>
  */
  @ActiveField()
  displayName?: null | string


/**
  * posterResourceId
  * Идентификатор ресурса-обложки. null — обложки нет,<br>витрина показывает первый кадр средствами плеера<br>
  */
  @ActiveField()
  posterResourceId?: null | string
}
